import HTTP from '@/config/axios-config-erp'

const ServiceRecogidasEntregas = {
  getRecogidas(payload) {
    return HTTP.post(`/wscomun/portalinformes/RecogidasEntregas`, payload).then(response => {
      return response
    }).catch(error => {
      console.log(error.response)
      return { 'status': 500 }
    })
  },
  getDetPedido(payload) {
    return HTTP.post(`/wscomun/portalinformes/DetRecogidasEntregas`, payload).then(response => {
      return response
    }).catch(error => {
      console.log(error.response)
      return { 'status': 500 }
    })
  },
  getPedidosAlbaranes(payload) {
    return HTTP.post(`/wscomun/portalinformes/estadoPedidosAlbaran`, payload).then(response => {
      return response
    }).catch(error => {
      console.log(error.response)
      return { 'status': 500 }
    })
  },
  getPedidosAlbaranesCab(payload) {
    return HTTP.post(`/wscomun/portalinformes/estadoPedidosAlbaranCab`, payload).then(response => {
      return response
    }).catch(error => {
      console.log(error.response)
      return { 'status': 500 }
    })
  },
  descargaCsvPedidosAlbaran(payload) {
    const payloadFinal = {
      tipoMensaje: 'DESCARGA_PORTAL_INF',
      webService: '/portalinformes/registrarWS',
      ...payload,
      timestampMs: Date.now()
    }
    return HTTP.post(`/wscomun/portalinformes/registrarWS`, payloadFinal).then(response => {
      return response
    }).catch(error => {
      console.log(error.response)
      return { 'status': 500 }
    })
  },
  setValidation(payload) {
    return HTTP.post(`/wscomun/portalinformes/validateService`, payload).then(response => {
      return response
    }).catch(error => {
      console.log(error.response)
      return { 'status': 500 }
    })
  },
  carteraRiesgosCliente(payload) {
    return HTTP.post(`/wscomun/portalinformes/carteraRiesgosCliente`, payload).then(response => {
      return response
    }).catch(error => {
      console.log(error.response)
      return { 'status': 500 }
    })
  },
  
}

export default ServiceRecogidasEntregas



// WEBPACK FOOTER //
// ./src/services/srv-recogidas-entregas.js